import { useQuery } from "@tanstack/react-query";
import { ApiClients } from "@/axios-config";
import { handleErrorToast } from "@/lib/utils";

export const useVersion = () =>
    useQuery({
        queryKey: ["app-version"],
        queryFn: async () => {
            try {
                const res = await ApiClients.Version.apiVersionGet();
                return res.data;
            } catch (err) {
                void handleErrorToast(err);
                return "";
            }
        },
    });

export const useTaggedVersion = () =>
    useQuery({
        queryKey: ["tagged-app-version"],
        queryFn: async () => {
            try {
                const res = await ApiClients.Version.apiVersionTaggedGet();
                return res.data;
            } catch (err) {
                void handleErrorToast(err);
                return "";
            }
        },
    });
